document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const headerRoot = document.querySelector('[data-header-shell]') || header?.parentElement;
  headerRoot?.classList.add('header-lock-root');
  let headerFrame = null;
  const updateHeader = () => {
    if (!header) return;
    const compact = window.scrollY > 72;
    header.classList.toggle('scrolled', compact);
    headerRoot?.classList.toggle('header-locked-scrolled', compact);
    document.body.classList.toggle('bondies-header-scrolled', compact);
    header.dataset.logoState = compact ? 'compact' : 'full';
    headerFrame = null;
  };
  window.addEventListener('scroll', () => {
    if (headerFrame !== null) return;
    headerFrame = window.requestAnimationFrame(updateHeader);
  }, { passive: true });
  updateHeader();

  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('.menu-overlay');
  const openMenu = () => { menu?.classList.add('open'); overlay?.classList.add('open'); document.body.classList.add('layer-open'); };
  const closeMenu = () => { menu?.classList.remove('open'); overlay?.classList.remove('open'); document.body.classList.remove('layer-open'); };
  document.querySelector('[data-menu-open]')?.addEventListener('click', openMenu);
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', closeMenu));

  const languageMenu = document.querySelector('.language-menu');
  if (languageMenu) {
    document.addEventListener('click', (event) => {
      if (!languageMenu.contains(event.target)) languageMenu.removeAttribute('open');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') languageMenu.removeAttribute('open');
    });
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantData = root.querySelector('[data-product-variants]');
    const form = root.querySelector('.bondies-product-form');
    if (!variantData || !form) return;
    const variants = JSON.parse(variantData.textContent);
    const idInput = form.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const submit = form.querySelector('[data-product-submit]');
    const mainImage = root.querySelector('.shopify-main-image');
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'SAR' }).format(cents / 100);

    const selectVariant = (updateUrl = true) => {
      const selected = [...root.querySelectorAll('[data-option-group]')].map((group) => group.querySelector('.variant-value.active')?.dataset.optionValue);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) { submit.disabled = true; submit.textContent = submit.dataset.unavailableLabel || 'Unavailable'; return; }
      idInput.value = variant.id;
      price.textContent = money(variant.price);
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? (submit.dataset.addLabel || 'Add to cart') : (submit.dataset.soldLabel || 'Sold out');
      const activeColourImage = root.querySelector('[data-option-image].active');
      const fallbackImage = activeColourImage?.dataset.optionImage;
      const nextImage = variant.featured_image?.src || fallbackImage;
      if (nextImage && mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.src = nextImage;
        mainImage.alt = variant.featured_image?.alt || activeColourImage?.dataset.optionAlt || variant.name || mainImage.alt || '';
        root.querySelectorAll('[data-gallery-image]').forEach((item) => {
          const galleryImage = item.dataset.galleryImage || '';
          item.classList.toggle('active', galleryImage === nextImage || galleryImage.includes(nextImage.split('?')[0]));
        });
      }
      if (updateUrl) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      }
    };

    root.querySelectorAll('.variant-value').forEach((button) => button.addEventListener('click', () => {
      const group = button.closest('[data-option-group]');
      group.querySelectorAll('.variant-value').forEach((item) => item.classList.toggle('active', item === button));
      const selectedLabel = group.querySelector('[data-selected-option]');
      if (selectedLabel) selectedLabel.textContent = button.dataset.optionValue;
      selectVariant();
    }));
    selectVariant(false);

    root.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      const input = root.querySelector('[data-quantity-input]');
      if (!input) return;
      const change = Number(button.dataset.quantityChange || 0);
      input.value = String(Math.max(1, Number(input.value || 1) + change));
    }));
  });

  document.querySelectorAll('[data-gallery-image]').forEach((button) => button.addEventListener('click', () => {
    const gallery = button.closest('.shopify-product-gallery');
    const image = gallery?.querySelector('.shopify-main-image');
    if (image) {
      image.removeAttribute('srcset');
      image.src = button.dataset.galleryImage;
      image.alt = button.dataset.galleryAlt || image.alt;
    }
    gallery?.querySelectorAll('[data-gallery-image]').forEach((item) => item.classList.toggle('active', item === button));
  }));

  document.querySelectorAll('[data-card-root]').forEach((card) => {
    const primaryImage = card.querySelector('.product-primary');
    const secondaryImage = card.querySelector('.product-alt');
    const quickAddVariant = card.querySelector('.quick-add-form input[name="id"]');
    const cardLinks = card.querySelectorAll('[data-card-link]');
    card.querySelectorAll('.card-swatch').forEach((swatch) => swatch.addEventListener('click', () => {
      card.querySelectorAll('.card-swatch').forEach((item) => item.classList.toggle('active', item === swatch));
      if (primaryImage && swatch.dataset.cardImage) {
        primaryImage.removeAttribute('srcset');
        primaryImage.src = swatch.dataset.cardImage;
        primaryImage.alt = swatch.dataset.cardAlt || primaryImage.alt || '';
        if (secondaryImage) {
          secondaryImage.removeAttribute('srcset');
          secondaryImage.src = swatch.dataset.cardImage;
          secondaryImage.alt = swatch.dataset.cardAlt || secondaryImage.alt || '';
        }
      }
      if (quickAddVariant && swatch.dataset.cardVariant) quickAddVariant.value = swatch.dataset.cardVariant;
      if (swatch.dataset.cardUrl) cardLinks.forEach((link) => { link.href = swatch.dataset.cardUrl; });
    }));
  });
});
